import { CaseItemStatus } from 'Portal/__generated__/globalTypes'

import { DashboardDeviceSlideTypeEnum } from './DashboardDevices.types'

const IMAGE_URL =
  'https://assets.everphone.app/device-definition/apple-iphone-8-plus-64gb-space-grau_300x400.png'

const NAME = 'Apple Iphone 8 Plus 64GB '
const IMEI = '356928106446448 '
const ID = '212345'
const START_AT = '12/01/2023'
const URL = 'http://'

export const DEVICE_SLIDE = [
  {
    id: ID,
    imageURL: IMAGE_URL,
    imei: IMEI,
    name: NAME,
    startAt: START_AT,
    type: DashboardDeviceSlideTypeEnum.Rental,
    url: URL,
  },
  {
    id: ID,
    imageURL: IMAGE_URL,
    imei: IMEI,
    name: NAME,
    startAt: START_AT,
    status: CaseItemStatus.new,
    type: DashboardDeviceSlideTypeEnum.Request,
    url: URL,
  },
  {
    id: ID,
    imageURL: IMAGE_URL,
    imei: IMEI,
    name: NAME,
    startAt: START_AT,
    status: CaseItemStatus.pending,
    type: DashboardDeviceSlideTypeEnum.Request,
    url: URL,
  },
  {
    id: ID,
    imageURL: IMAGE_URL,
    imei: IMEI,
    name: NAME,
    startAt: START_AT,
    status: CaseItemStatus.done,
    type: DashboardDeviceSlideTypeEnum.Request,
    url: URL,
  },
  {
    id: ID,
    imageURL: IMAGE_URL,
    imei: IMEI,
    name: NAME,
    startAt: START_AT,
    status: CaseItemStatus.in_progress,
    type: DashboardDeviceSlideTypeEnum.Request,
    url: URL,
  },
]
